
import {
    defineComponent,
    ref
} from 'vue';

import MyTimelineItem from "@/components/TimelinePage/MyTimelineItem.vue";
import MyFloatingCard from "@/components/TimelinePage/MyFloatingCard.vue";
import {
    useStore
} from '../store';

export default defineComponent({
    setup() {
        const store = useStore();
        const state = ref(store.state);

        return {
            state
        };
    },
    components: {
        MyFloatingCard,
        MyTimelineItem
    }

});
